import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Cashout {

  static endpoints = {
    index      : `${baseUrl}/cashout`,
    currencies : `${baseUrl}/cashout/currencies`,
  };

  static statusList = {
    0 : { label: "Pending"  , class : "warning"},
    1 : { label: "Accepted" , class : "success"},
    2 : { label: "Blocked"  , class : "danger"},
    3 : { label: "Rejected" , class : "danger"},
    4 : { label: "On Hold"  , class : "info"   },
    5 : { label: "On Hold"  , class : "info"   },
  };

  static paginators = {
    history : (data)=> axios.get(`${this.endpoints.index}/`     , {params: data}).then((response)=> response.data.cashouts.items),
    types   : (data)=> axios.get(`${this.endpoints.index}/types`, {params: data}).then((response)=> response.data.types.items),
  };

  static create(payload) {
    return axios.post(this.endpoints.index, payload).then((response)=> response.data.message);
  };

  static currencies() {
    return axios.get(this.endpoints.currencies).then((response)=> response.data.currencies);
  };

}
